export const REFERRAL_HOME_PAGE_VIEWED = 'Refer - Referral Home Page Viewed';
export const LEADERBOARD_AWARENESS_CARD_CLICKED =
  'Refer - Leaderboard Awareness Card Clicked';
export const LEADERBOARD_VIEW_ALL_CLICKED =
  'Refer - Leaderboard View All Clicked';
export const CHAT_WITH_US_CLICKED = 'Chat - Chat With Us Clicked';
export const REFERRAL_REWARD_INFO_CLICKED =
  'Refer - Referral Reward info clicked';
export const REFERRAL_REWARD_KNOW_MORE = 'Refer - Rewards Know More';
export const REFER_FAQ_CLICKED = 'Refer - FAQ Clicked';
export const REFER_TERMS_CLICKED = 'Refer - Terms and Conditions Clicked';
export const REFER_CODE_SHARED = 'Refer - Code Shared';
export const REFER_EXIT_INTENT_VIEWED = 'Refer - Exit Intent Viewed';
export const REFER_EXIT_INTENT_SUBMITTED = 'Refer - Exit Intent Submitted';

export const REWARD_TYPES = {
  VOUCHER: 'Amazon voucher',
  EXTENSION: 'Plus subscription',
  LAPTOP: 'Laptop',
  TSHIRT: 'Tshirt',
  MOREREWARDS: 'more_on_rewards'
};

export const REWARD_COLORS = {
  Voucher: 'var(--color-i-orange-20)',
  Extension: 'var(--color-i-blue-36)',
  Laptop: 'var(--color-i-gray-2)'
};
export const CARD_TYPES = {
  HERO_CARD: 'hero_card',
  REFER_YOUR_FRIENDS: 'refer_your_friends',
  REFERRALS: 'referrals',
  AVAILABLE_REWARDS: 'available_rewards',
  IMPORTANT_NOTES: 'important_notes',
  EARNED_REWARDS: 'earned_rewards',
  GRANTED_REWARDS: 'granted_rewards',
  NO_REWARDS: 'no_reward_reasons',
  REFERRAL_BENEFITS: 'paid_referral_benefits_card',
  SOCIAL_PROOFING: 'social_proofing',
  LAPTOP_WINNERS: 'laptop_winners',
  HALL_OF_FAME: 'hall_of_fame'
};

export const PAID_USER = 'Paid';

export const colorList = ['#FFAD3B', '#7A8B94', '#C57F4C'];

export const numberFormatter = (num) => {
  if (num < 1000) {
    return num;
  }
  if (num < 100000) {
    return `${(Math.abs(num) / 1000).toFixed(1)}K`;
  }
  if (num < 10000000) {
    return `${(Math.abs(num) / 100000).toFixed(1)}L`;
  }
  return `${(Math.abs(num) / 10000000).toFixed(1)}Cr`;
};

export const defaultMarginIndex = 16;

export const STATUS = {
  skip: 1,
  submit: 2
};

export const REFERRAL_EXIT_INTENT = 'referral_exit_intent';

export const defaultWebWinnerCardWidth = 178;

export const defaultMwebWinnerCardWidth = 148;

export const manageGoals = '/explore';
